import { FC } from 'react';
import { MdInfo } from 'react-icons/md';
import { MFlex, MIcon, MSwitch, MText, MTooltip } from '.';

interface TermsPreviewToggleProps {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  /** Stable QA hook — must stay unique across a single screen */
  testId: string;
}

/**
 * Switch that turns on the resolved-value preview for rich text terms.
 * Shared so the label and tooltip copy stay identical across every terms
 * surface — QA selects the switch by its accessible name.
 */
export const TermsPreviewToggle: FC<TermsPreviewToggleProps> = ({
  isChecked,
  onChange,
  testId,
}) => (
  <MFlex alignItems="center" gap={2}>
    <MFlex alignItems="center">
      <MText fontSize="sm">Preview with quote data</MText>
      <MTooltip
        label="Terms can contain variables, such as {{quote.amount}}. Turn this on to see them replaced with this quote's actual values."
        placement="bottom-start"
      >
        <MFlex alignItems="center">
          <MIcon as={MdInfo} color="tPurple.base" ml="1" />
        </MFlex>
      </MTooltip>
    </MFlex>
    <MSwitch
      size="sm"
      isChecked={isChecked}
      onChange={(ev) => onChange(ev.target.checked)}
      aria-label="Preview terms with quote data"
      data-testid={testId}
    />
  </MFlex>
);
